var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointmentMsg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27150",
    "data-name": "Group 27150",
    transform: "translate(-397 -182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13394",
    "data-name": "Rectangle 13394",
    width: 32,
    height: 32,
    transform: "translate(397 182)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "messages",
    transform: "translate(403 189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45411",
    "data-name": "Path 45411",
    d: "M3.656,17.979A1,1,0,0,1,2,17.243V15a2,2,0,0,1-2-2V6A2,2,0,0,1,2,4H13a2,2,0,0,1,2,2v7a2,2,0,0,1-2,2H8L3.656,17.979ZM4.5,14.886a.536.536,0,0,0,.26-.069l2.355-1.638A1,1,0,0,1,7.686,13H12a1,1,0,0,0,1-1V7a1,1,0,0,0-1-1H3A1,1,0,0,0,2,7v5a1.007,1.007,0,0,0,1,1,1.3,1.3,0,0,1,.844.226c.128.134.135.36.156.79,0,.063,0,.177,0,.37A.5.5,0,0,0,4.5,14.886Z",
    transform: "translate(0 -0.224)",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45412",
    "data-name": "Path 45412",
    d: "M16,10.017q0,.184,0,.369v-.37c.02-.43.028-.656.156-.79A1.3,1.3,0,0,1,17,9a1.007,1.007,0,0,0,1-1V3a1,1,0,0,0-1-1H8A1,1,0,0,0,7,3H5V2A2,2,0,0,1,7,0H18a2,2,0,0,1,2,2V9a2,2,0,0,1-2,2v2.243a1,1,0,0,1-1.656.736L16,13.743Z",
    fill: "#8A8A8A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentMsg);
export default __webpack_public_path__ + "static/media/appointment_msg.9e835d4c.svg";
export { ForwardRef as ReactComponent };